import {useState} from "react";
import {useNavigate} from "react-router-dom";

import {REQUIRED_FILES} from "../model/requiredUploadFiles";
import {checkFilesRequired} from "../model/checkFilesRequired";
import {loadStoredApplication} from "../model/loadStoredApplication";


import {createCase} from "../api/createCase";
import {APPLICATION_ATTACHMENTS} from "../../../utils/constants";
import {uploadFile} from "../../../utils/uploadFile";
import {
  NEW_APPLICATION_STEP3_MODAL_CONTENT
} from "../components/NewApplicationStep3ModalContent/NewApplicationStep3ModalContent";

export const useNewApplicationStep3 = ({ category, files }) => {
  const [dialogContent, setDialogContent] = useState<NEW_APPLICATION_STEP3_MODAL_CONTENT | ''>('');
  const navigate = useNavigate();

  const submit = async () => {
    try {
      if (checkFilesRequired({ category, files })) {
        setDialogContent(NEW_APPLICATION_STEP3_MODAL_CONTENT.LOADING);
        const storedCase = loadStoredApplication();
        const lineToken = localStorage.getItem('lineToken')

        // Upload files & get URLs
        const urls = {};

        for (const attachmentKey of REQUIRED_FILES[category]) {
          const urlKey = `${attachmentKey}Url`
          const bucket = APPLICATION_ATTACHMENTS[attachmentKey].bucket;

          urls[urlKey] = files[attachmentKey] ? await uploadFile(files[attachmentKey], `cases/${bucket}`) : '';
        }

        const newCase = {
          ...storedCase,
          ...urls,
        };

        await createCase({ token: lineToken, creatingCase: newCase })
        localStorage.setItem("newCase", JSON.stringify({}));
        setDialogContent(NEW_APPLICATION_STEP3_MODAL_CONTENT.COMPLETE);
      } else {
        setDialogContent(NEW_APPLICATION_STEP3_MODAL_CONTENT.NOT_ALL_SELECTED);
      }
    } catch (error) {
      setDialogContent(NEW_APPLICATION_STEP3_MODAL_CONTENT.ERROR);
    }
  }

  const onCloseSuccessMessage = () => setDialogContent('')
  const onClickGoHome = () => navigate('/platform')
  const onClickGoTrack = () => navigate('/applicationList')

  return { dialogContent, submit, onCloseSuccessMessage, onClickGoHome, onClickGoTrack }
}